import React from 'react';
import { useSelector } from 'react-redux';

const PipelineStatusEditorTabs = ({ statusId, onChange = () => {} }) => {
  const pipelineLeadStatuses = useSelector((state) => state.app.pipeline_lead_statuses) || [];

  const handleChange = (e, n) => {
    e.preventDefault();
    if (n.id !== statusId) {
      onChange({ statusId: n.id, subStatusId: null, note: '', statusDate: new Date(), changeSource: 'statusEditorTabs' });
    }
  };

  return (
    <ul className={`status-tabs`}>
      {pipelineLeadStatuses.map((n) => (
        <li key={n.id} className={`btn btn-${n.status.toLowerCase()} ${statusId && n.id === statusId ? 'active' : ''}`} onClick={(e) => handleChange(e, n)}>
          {n.status}
        </li>
      ))}
    </ul>
  );
};

export default PipelineStatusEditorTabs;
